import * as types from "../types";

export default {
  [types.GET_PROJECT_DATALIST](state, data) {
    state.projectData = data;
  },
  [types.GET_CRM_PROJECT_DATALIST](state, data) {
    state.crmProjectData = data;
  },
  [types.GET_PROJECT_DETAIL](state, data) {
    state.detail = data;
  },
  [types.GET_PROJECT_TEAM](state, data) {
    state.projectTeam = data;
  },
  [types.GET_PROJECT_LIST_SELECT](state, data) {
    state.projectListSelect = data;
  },
  [types.GET_PROJECT_CUSTOMER](state, data) {
    state.projectCustomer = data;
  },
  [types.GET_PROJECT_CUSTOMER_SELECT](state, data) {
    state.projectCustomerSelect = data;
  },
  [types.GET_PROJECT_CONTRACT_SELECT](state, data) {
    state.projectContractSelect = data;
  },
  [types.GET_PROJECT_SALESMAN_SELECT](state, data) {
    state.projectSalesmanSelect = data;
  },
  [types.GET_PROJECT_PACKAGELIST](state, data) {
    state.projectPackage = data;
  },
};
